import { env } from 'src/env/client.mjs'

const defaultAvatarMap: {
  expression: RegExp
  url: string
}[] = [
  {
    expression: /^[a-d]/i,
    url: '/img/default-profile/default-profile-0.jpeg'
  },
  {
    expression: /^[e-h]/i,
    url: '/img/default-profile/default-profile-1.jpeg'
  },
  {
    expression: /^[i-l]/i,
    url: '/img/default-profile/default-profile-2.jpeg'
  },
  {
    expression: /^[m-p]/i,
    url: '/img/default-profile/default-profile-3.jpeg'
  },
  {
    expression: /^[q-t]/i,
    url: '/img/default-profile/default-profile-4.jpeg'
  },
  {
    expression: /^[u-w]/i,
    url: '/img/default-profile/default-profile-5.jpeg'
  },
  {
    expression: /^[x-z]/i,
    url: '/img/default-profile/default-profile-6.jpeg'
  }
]

const DEFAULT_AVATAR = 'assets/img/default-profile.png'

export const getDefaultAvatar = (
  name: string,
  avatar?: string | null
): string => {
  if (!!avatar && avatar !== DEFAULT_AVATAR) {
    return `${env.NEXT_PUBLIC_ASSETS_DOMAIN}/${avatar}`
  }
  const matchedUrl = defaultAvatarMap.find(a =>
    a.expression.test(name.trim())
  )?.url
  return matchedUrl || defaultAvatarMap[0]!.url
}
